import { render, staticRenderFns } from "./LeicesterPerson.vue?vue&type=template&id=c9b323aa&"
import script from "./LeicesterPerson.vue?vue&type=script&lang=js&"
export * from "./LeicesterPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports